import { render } from "./NewCamsLadies.vue?vue&type=template&id=569f63ee"
import script from "./NewCamsLadies.vue?vue&type=script&lang=js"
export * from "./NewCamsLadies.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/landing2.elena-dating.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__